var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"es-page-box"},[_c('el-pagination',{attrs:{"background":"","small":"","layout":"total, prev, pager, next, jumper","page-size":_vm.data.pageSize,"current-page":_vm.data.pageNum,"total":_vm.data.total},on:{"current-change":_vm.checkChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }